import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { reduceMotion } from '@js/animations/ReducedMotion'
import { createOnceOnEnter, isInViewport } from '@js/animations/scrollTriggerHelper'

export class Stagger {
  constructor () {
    this.stagger()
    this.stagger_single()
  }

  stagger () {
    const elements = document.querySelectorAll('[animation-stagger]')

    if (!elements.length) {
      return
    }

    if (reduceMotion) {
      gsap.set(elements, { autoAlpha: 1, y: 0 })
      return
    }

    gsap.set('[animation-stagger]', { y: 60, autoAlpha: 0 })

    const animateIn = (batch) => {
      gsap.to(batch, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.15,
        duration: 0.7,
        ease: 'power2.out',
      })
    }

    ScrollTrigger.batch('[animation-stagger]', {
      onEnter: animateIn,
      once: true,
      start: 'top 90%',
    })

    requestAnimationFrame(() => {
      const visible = [...elements].filter((el) => isInViewport(el))

      if (visible.length) {
        animateIn(visible)
      }
    })
  }

  stagger_single () {
    this._elements = document.querySelectorAll('[animation-stagger-single]')

    if (!this._elements.length) {
      return
    }

    this._elements.forEach((element) => {
      const delay = parseFloat(element.getAttribute('animation-stagger-single')) || 0
      const isHero = element.closest('.s-hero')

      const animate = () => {
        gsap.to(element, {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          delay,
          ease: 'power2.out',
        })
      }

      if (reduceMotion) {
        gsap.set(element, { autoAlpha: 1, y: 0 })
        return
      }

      gsap.set(element, { y: 20, autoAlpha: 0 })

      if (isHero) {
        animate()
      } else {
        createOnceOnEnter({
          trigger: element,
          onEnter: animate,
        })
      }
    })
  }
}
